import React from 'react'

import styled from '@emotion/styled'
import { Box, Display, DisplayPosition, Image } from '@gousto-internal/citrus-react'

import { TextBlock } from './TextBlock'
import { Tooltip, TooltipVariant, TooltipArrowType } from './Tooltip'
import { FRESH_INGREDIENTS } from './data'

const Container = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',

  '@media (max-width: 640px)': {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '24px',
  },
})

const RoundContainer = styled.div({
  width: '260px',
  height: '260px',
  borderRadius: '100%',
  overflow: 'hidden',

  '@media (max-width: 640px)': {
    marginTop: '16px',
  },
})

export const IngredientsSection = () => {
  const [leftTooltipText, rightTooltipText] = FRESH_INGREDIENTS.tooltips

  return (
    <Container data-testid="IngredientsSection">
      <TextBlock title={FRESH_INGREDIENTS.title} text={FRESH_INGREDIENTS.text} />

      <Box display={Display.Flex} position={DisplayPosition.Relative}>
        <Box position={DisplayPosition.Absolute} left="-30px" top="30px">
          <Tooltip
            arrow={TooltipArrowType.RIGHT}
            variant={TooltipVariant.LIGHT}
            text={leftTooltipText}
          />
        </Box>
        <Box position={DisplayPosition.Absolute} right="-40px" top="80px">
          <Tooltip
            arrow={TooltipArrowType.LEFT}
            variant={TooltipVariant.LIGHT}
            text={rightTooltipText}
          />
        </Box>
        <RoundContainer>
          <Image src={FRESH_INGREDIENTS.imageSource} alt={FRESH_INGREDIENTS.title} />
        </RoundContainer>
      </Box>
    </Container>
  )
}
